module.exports = __webpack_public_path__ + "img/message_white_48dp.f98f0ebb.svg";